/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetPreferencesResponseJson } from './get-preferences-response-json';
import { GetPreferencesResult } from '../results/get-preferences-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { PreferenceDto } from '../models/preference-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetPreferencesResponse extends ResponseWithErrorGeneric<GetPreferencesResponseJson, GetPreferencesResult> implements IResponseWithErrorGeneric<GetPreferencesResult> {
  public preferences: PreferenceDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetPreferencesResponse>) {
    super(response, GetPreferencesResult.Error);
    if (this.result !== GetPreferencesResult.Success) {
      return;
    }

    this.preferences = this.body.preferences ? this.body.preferences : [];
  }
  //</custom-body>
}
